// TopNavbar.jsx
import { useState, useRef } from "react";
import { Menu, MessageSquare, Copy, Settings, User } from "lucide-react";
import SettingsDropdown from "./topNavbarTool/setting";
import ProfileDropdown  from "./topNavbarTool/ProfileDropdown";
import "../styles/topNavbar.css";

export default function TopNavbar({ onToggleSidebar, onLogout }) {
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [profileOpen,  setProfileOpen]  = useState(false);
  const settingsWrapperRef = useRef(null);
  const profileWrapperRef  = useRef(null);

  // ── Read logged-in user from localStorage ──
  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const displayName  = storedUser.username || "User";
  const displayEmail = storedUser.email    || "";

  function handleSettingSelect(label) {
    console.log("Setting selected:", label);
  }

  return (
    <div className="navbar">
      {/* ── Left ── */}
      <div className="navbar-left">
        <button className="navbar-menu-btn" onClick={onToggleSidebar}>
          <Menu size={20} />
        </button>
        <div className="navbar-logo">
          <div className="navbar-logo-icon"><span>A</span></div>
          <span className="navbar-app-name">Voxel Mind</span>
        </div>
      </div>

      {/* ── Right ── */}
      <div className="navbar-right">
        {/* <button className="navbar-icon-btn"><MessageSquare size={18} /></button>
        <button className="navbar-icon-btn"><Copy size={18} /></button> */}

        <div ref={settingsWrapperRef} className="navbar-settings-wrapper">
          <Settings
            size={18}
            className={`navbar-settings-icon${settingsOpen ? " active" : ""}`}
            onClick={() => { setSettingsOpen(v => !v); setProfileOpen(false); }}
          />
          <SettingsDropdown
            isOpen={settingsOpen}
            onClose={() => setSettingsOpen(false)}
            onSelect={handleSettingSelect}
          />
        </div>

        {/* ── User avatar ── */}
        <div
          ref={profileWrapperRef}
          className="navbar-user navbar-user--clickable"
          onClick={() => { setProfileOpen(v => !v); setSettingsOpen(false); }}
          role="button"
          tabIndex={0}
          aria-haspopup="true"
          aria-expanded={profileOpen}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setProfileOpen(v => !v);
            }
          }}
        >
          <div className={`navbar-user-avatar${profileOpen ? " active" : ""}`}>
            <User size={14} color="white" />
          </div>

          {/* ── Dynamic name in navbar ── */}
          <span className="navbar-user-name">{displayName}</span>

          {/* ── Dynamic name+email in dropdown ── */}
          <ProfileDropdown
            isOpen={profileOpen}
            onClose={() => setProfileOpen(false)}
            userName={displayName}
            userEmail={displayEmail}
            onLogout={onLogout}
          />
        </div>
      </div>
    </div>
  );
}